export const unique = <T>(values: Iterable<T>): T[] => {
  return Array.from(new Set(values));
};

export const toArray = <T>(value: T | T[] | undefined | null): T[] => {
  if (value === undefined || value === null) return [];
  return Array.isArray(value) ? value : [value];
};
